import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                男
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                男人团
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              专为现代男性打造的成长型社群平台。聚焦健康、事业、情感与自我提升，与兄弟一起突破自我。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/category/health" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  男性健康
                </Link>
              </li>
              <li>
                <Link to="/category/career" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  事业突破
                </Link>
              </li>
              <li>
                <Link to="/category/relationship" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  情感关系
                </Link>
              </li>
              <li>
                <Link to="/category/self-growth" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  自我提升
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#testimonials" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  会员口碑
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors" rel="nofollow">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">
              关注我们
            </h4>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              获取最新社群动态和精选内容
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="微信公众号">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-sm">
            &copy; {new Date().getFullYear()} 男人团 版权所有
          </p>
          <p className="text-foreground-600 text-xs">
            与兄弟同行，突破自我界限
          </p>
        </div>
      </div>
    </footer>
  );
}